// components/AuthProvider.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { fetchUserPermissions } from "../axios/permissionsService"
import * as actionTypes from 'store/actions';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { accounts } = useMsal();
  const permissionsLoaded = useSelector((state) => state.permissions.loaded);

  useEffect(() => {
    const loadPermissions = async () => {
      if (accounts.length > 0 && !permissionsLoaded) {
        dispatch({ type: actionTypes.FETCH_PERMISSIONS_REQUEST });
        
        try {
          const permissions = await fetchUserPermissions();
          
          console.log('Permissions loaded:', permissions); 
          
          dispatch({
            type: actionTypes.FETCH_PERMISSIONS_SUCCESS,
            payload: permissions
          });
        } catch (error) {
          console.error('Failed to load permissions:', error);
          dispatch({
            type: actionTypes.FETCH_PERMISSIONS_FAILURE,
            error: error.message
          });
        }
      }
    };

    loadPermissions();
  }, [accounts, dispatch, permissionsLoaded]);

  return children;
};

export default AuthProvider;